import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import unauthenticatedRoutes from './unauthenticated';
import authenticatedRoutes from './authenticated';
import authorizeAccess from './security/access';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  ...unauthenticatedRoutes,
  ...authenticatedRoutes,
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '*',
    component: () => import('@/vue-app/layouts/UnauthenticatedLayout.vue'),
    children: [
      {
        path: '*',
        component: () => import('@/vue-app/views/NotFound.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(authorizeAccess);

export default router;
